import useIsPaymentSystemV2Enabled from '../../modules/PaymentOrder/hooks/useIsPaymentSystemV2Enabled';
import useGetCompanyById from './useGetCompanyById';

export default function useIsMonthlyQuotaEnabled(): boolean {
  const { company } = useGetCompanyById();
  const isPaymentSystemV2Enabled = useIsPaymentSystemV2Enabled();

  return isPaymentSystemV2Enabled && Boolean(company?.isMonthlyQuotaEnabled);
}
